import React, { useState } from "react";
import styles from "../Styles/ActivityLogs.module.css";

const MOCK_LOGS = [
  {
    id: "1",
    type: "SETTINGS",
    title: "Portaaliasetuksia päivitettiin",
    description: "Sidebar-konfiguraatiota muutettiin",
    details: ["Dokumentit lisättiin", "Järjestystä päivitettiin"],
    user: "Jani Rantala",
    role: "hallitus",
    createdAt: "12.9.2025 klo 18:42",
  },
  {
    id: "2",
    type: "USER",
    title: "Käyttäjän roolia muutettiin",
    description: "Käyttäjä Marko Ceder",
    details: ["Lisättiin rooli: isännöitsijä"],
    user: "Admin",
    role: "admin",
    createdAt: "10.9.2025 klo 09:15",
  },
];

const TYPE_META = {
  SETTINGS: { icon: "⚙️", color: "#6c757d" },
  USER: { icon: "👤", color: "#2f7dd1" },
  ANNOUNCEMENT: { icon: "📢", color: "#c7922b" },
  SERVICE_REQUEST: { icon: "🛠️", color: "#3a9d6f" },
};

export default function ActivityLogs() {
  const [typeFilter, setTypeFilter] = useState("ALL");
  const [userFilter, setUserFilter] = useState("ALL");
  const [timeFilter, setTimeFilter] = useState("30");

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        {/* Otsikko */}
        <header className={styles.header}>
          <h1>Toimintoloki</h1>
          <p className={styles.description}>
            Näet taloyhtiössä tehdyt merkittävät muutokset ja toimenpiteet.
          </p>
        </header>

        {/* Suodattimet */}
        <section className={styles.filters}>
          <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
            <option value="ALL">Kaikki tapahtumat</option>
            <option value="SETTINGS">Asetukset</option>
            <option value="USER">Käyttäjät</option>
            <option value="ANNOUNCEMENT">Tiedotteet</option>
            <option value="SERVICE_REQUEST">Palvelupyynnöt</option>
          </select>

          <select value={userFilter} onChange={(e) => setUserFilter(e.target.value)}>
            <option value="ALL">Kaikki käyttäjät</option>
            <option value="Jani Rantala">Jani Rantala</option>
            <option value="Admin">Admin</option>
          </select>

          <select value={timeFilter} onChange={(e) => setTimeFilter(e.target.value)}>
            <option value="7">Viimeiset 7 päivää</option>
            <option value="30">Viimeiset 30 päivää</option>
            <option value="90">Viimeiset 90 päivää</option>
          </select>
        </section>

        {/* Lokilista */}
        <section className={styles.logList}>
          {MOCK_LOGS.map((log) => {
            const meta = TYPE_META[log.type] || {};
            return (
              <div
                key={log.id}
                className={styles.logCard}
                style={{ borderLeftColor: meta.color || "#444" }}
              >
                <div
                  className={styles.iconWrap}
                  style={{ backgroundColor: meta.color || "#444" }}
                >
                  {meta.icon}
                </div>

                <div className={styles.logContent}>
                  <div className={styles.logHeader}>
                    <strong>{log.title}</strong>
                    <span className={styles.meta}>
                      {log.user} ({log.role})
                    </span>
                  </div>

                  <div className={styles.logDescription}>{log.description}</div>

                  {log.details?.length > 0 && (
                    <ul className={styles.details}>
                      {log.details.map((d, i) => (
                        <li key={i}>{d}</li>
                      ))}
                    </ul>
                  )}

                  <div className={styles.timestamp}>
                    🕒 {log.createdAt}
                  </div>
                </div>
              </div>
            );
          })}

          {MOCK_LOGS.length === 0 && (
            <div className={styles.emptyState}>
              <p>Ei vielä kirjattuja tapahtumia.</p>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
